function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import "./LineNumbers.css";

var LineNumbers = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LineNumbers, _Component);

  function LineNumbers() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = LineNumbers.prototype;

  _proto.determineCount = function determineCount() {
    var height = this.props.height;
    var adjustedHeight = height - 14 * 2;
    var maxLines = adjustedHeight > 0 ? Math.floor(adjustedHeight / 21) : 1;
    var arrayCount = [];

    for (var i = 1; i <= maxLines; i++) {
      arrayCount.push(i);
    }

    return arrayCount;
  };

  _proto.render = function render() {
    var count = this.determineCount();
    var lineClasses = classnames('LineNumbers', this.props.className);
    return /*#__PURE__*/React.createElement("div", {
      className: lineClasses
    }, count.map(function (num) {
      return /*#__PURE__*/React.createElement("span", {
        key: "line-" + num,
        className: "LineNumbers__number"
      }, num);
    }));
  };

  return LineNumbers;
}(Component);

LineNumbers.propTypes = {
  height: PropTypes.number.isRequired
};
export default LineNumbers;
//# sourceMappingURL=LineNumbers.js.map